<template>
  <div class="user-center">
    <router-view></router-view>
  </div>
</template>

<script>
export default {

};
</script>

<style scoped>
.user-center {
  height: 100%;
}
</style>
